import React, { useEffect } from 'react'
import styled from 'styled-components'
import Typography from '@ntuctech/devex-tangram/Typography'
import { SvgSuccess } from '@ntuctech/devex-tangram'
import WorkpalIcon from '../icons/svg/workpal.svg'
import {
  LAUNCH_WORKPAL,
  HOW_AUTHENCTICATE,
  EMAIL_VERIFIED,
} from '../../utils/constants/payments'
import getConfig from 'next/config'
import Image from '../Image/Image'
import { useCountdown } from '../SwimlaneCountdown/SwimlaneCountdown'

const {
  publicRuntimeConfig: { ENVIRONMENT },
} = getConfig()

const EmailVerifiedLine = styled.div`
  margin-top: 0.75rem;
  display: flex;
  padding: 0.75rem;
  background: #e8f0fd;
  font-size: 0.85rem !important;
`

const EmailVerifiedTitle = styled(Typography)`
  font-size: 0.938rem;
  line-height: 1.5rem;
`
const HowToAuth = styled.a`
  margin-top: 0.75rem;
  margin-bottom: 3rem;
  color: #1557bf;
  font-weight: 600;
  text-decoration: none;
`

const WorkpalContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 1.5rem;
`

const TimerContainer = styled.div`
  margin-left: 1rem;
`

const CORP_BILLING_INSTRUCTIONS =
  ENVIRONMENT === 'PROD' || ENVIRONMENT === 'PRODPREVIEW'
    ? 'https://app.dwp.gov.sg/svp/corpbillinginstructions/'
    : 'https://uat.app.dwp.gov.sg/svp/corpbillinginstructions/'

const formatTime = timeInSeconds => {
  const minutes = Math.floor(timeInSeconds / 60)
  const remainingSeconds = timeInSeconds % 60
  const formattedMinutes = String(minutes).padStart(2, '0')
  const formattedSeconds = String(remainingSeconds).padStart(2, '0')
  return `${formattedMinutes}:${formattedSeconds}`
}

const EmailVerified = ({ onClose }) => {
  const timeRemaining = useCountdown(120, false)
  const formattedCountdown = formatTime(timeRemaining)

  useEffect(() => {
    if (formattedCountdown === '00:00') {
      onClose()
    }
  }, [formattedCountdown, onClose])

  return (
    <>
      <EmailVerifiedLine>
        <SvgSuccess size="s" color="#1557BF" />
        &nbsp;&nbsp;{EMAIL_VERIFIED}
      </EmailVerifiedLine>
      <WorkpalContainer>
        <Image src={WorkpalIcon} reservedHeight="4rem" reservedWidth="4rem" />
        <TimerContainer>
          <div style={{ marginBottom: '0.5rem' }}>
            <EmailVerifiedTitle variant="h5">
              {LAUNCH_WORKPAL}
            </EmailVerifiedTitle>
            <span style={{ color: '#666', lineHeight: '1.25rem' }}>
              Time Remaining: <b>{formattedCountdown}</b>
            </span>
          </div>
          <HowToAuth href={CORP_BILLING_INSTRUCTIONS} target="_blank">
            {HOW_AUTHENCTICATE}
          </HowToAuth>
        </TimerContainer>
      </WorkpalContainer>
    </>
  )
}
export default EmailVerified
